/**
 * Personenfarben-Palette — erdige Marken-Palette (10 – UI/UX, aus dem Logo).
 * Spiegelt die CSS-Tokens in tokens.css. Verwendung: Avatar-Ring, Event-Balken,
 * Feed-Autorenzeile, Chat-Namen. IMMER mit Name/Avatar kombiniert — nie
 * alleiniger Informationsträger (04 – NFR).
 */
export const PERSON_COLORS = [
  '#37434e', // Schiefer-Navy
  '#66743f', // Olivgrün
  '#c6994f', // Ocker/Sand
  '#bc6f55', // Terrakotta
  '#7e8c5a', // Salbei
  '#94764f', // Warmbraun
  '#5e7c86', // gedämpftes Petrol
  '#8a6478', // Mauve
  '#4e8375', // Tannengrün
  '#b58a3c', // Senf
] as const

export type PersonColor = (typeof PERSON_COLORS)[number]

/** Stabile Farbzuordnung anhand eines Indexes (z. B. Reihenfolge der Member). */
export function personColor(index: number): PersonColor {
  return PERSON_COLORS[index % PERSON_COLORS.length] as PersonColor
}

/**
 * Kontrastsichere Textfarbe aus einer Personenfarbe (Mittel). Helle erdige Töne
 * (Ocker/Sand/Senf/Salbei) liegen als reine Textfarbe auf Warmweiß unter WCAG-AA.
 * Der Farbton bleibt erhalten, wird aber Richtung Text-Ink abgedunkelt → AA-tauglich,
 * ohne die Farbcodierung zu verlieren. Funktioniert auch im Dark Mode (mischt gegen
 * das dann helle --color-ink).
 */
export function personTextColor(color: string): string {
  return `color-mix(in srgb, ${color} 55%, var(--color-ink))`
}
